import {
  Heart,
  Phone,
  Mail,
  MapPin,
  Facebook,
  Instagram,
  MessageCircle,
  PhoneCall,
} from "lucide-react";
import cover from "../assets/icons/cover.webp"; 
import qr from "../assets/docs/qr.webp"; 



export default function Footer({ onNavigate }) {
  return (
    <footer style={{ background: "#111D18", color: "rgba(255,255,255,0.75)" }}>
      <div className="ribbon-divider" />
      <div className="container" style={{ padding: "2rem 1.5rem 2rem" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "2.5rem", marginBottom: "3rem" }}>
          {/* Brand */}
          <div>
      <img
  src={cover}
  alt="Birati Child Care"
  style={{
    width: 150,
    height: "auto",
    display: "block",
    marginBottom: "1rem",
  }}
/>
            <p style={{ fontSize: "0.88rem", lineHeight: 1.7, marginBottom: "1.25rem" }}>
              To help children below poverty level.
            </p>
            <div style={{ display: "flex", gap: "0.6rem", flexWrap: "wrap" }}>
  <a
    href="https://www.facebook.com/p/Birati-Childcare-Foundation-100083366125127/"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      width: 34,
      height: 34,
      borderRadius: "50%",
      background: "var(--gold)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#1B4332",
    }}
  >
    <Facebook size={15} />
  </a>

  <a
    href="https://www.instagram.com/"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      width: 34,
      height: 34,
      borderRadius: "50%",
      background: "var(--gold)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#1B4332",
    }}
  >
    <Instagram size={15} />
  </a>

  <a
    href="https://wa.me/919830019844"
    target="_blank"
    rel="noopener noreferrer"
    title="WhatsApp"
    style={{
      width: 34,
      height: 34,
      borderRadius: "50%",
      background: "var(--gold)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#1B4332",
    }}
  >
    <MessageCircle size={15} />
  </a>

  <a
    href="tel:+919830019844"
    title="Call"
    style={{
      width: 34,
      height: 34,
      borderRadius: "50%",
      background: "var(--gold)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#1B4332",
    }}
  >
    <PhoneCall size={15} />
  </a>
</div>
          </div>

         

          {/* Contact */}
          <div>
            <h4 style={{ color: "#fff", fontFamily: "var(--font-label)", fontSize: "0.8rem", letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: "1rem" }}>Contact</h4>
            {[
              [MapPin, " 596/3 M.B. Road, (Banik More), Birati, North 24 parganas, pin- 700051"],
              [Phone, "+91 98300 19844"],
              [Mail, "biratichildcarefoundation@gmail.com"],
            ].map(([Icon, text], i) => (
              <div key={i} style={{ display: "flex", gap: "0.65rem", marginBottom: "0.8rem", alignItems: "flex-start" }}>
                <Icon size={15} style={{ color: "var(--gold)", flexShrink: 0, marginTop: 2 }} />
                <span style={{ fontSize: "0.87rem" }}>{text}</span>
              </div>
            ))}
          </div>

          {/* Donate CTA */}
          <div>
            <h4 style={{ color: "#fff", fontFamily: "var(--font-label)", fontSize: "0.8rem", letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: "1rem" }}>Support a Child</h4>
            
            <button className="btn btn-primary" onClick={() => onNavigate("contact")} style={{ width: "100%" }}>
              <Heart size={15} /> Donate Us
            </button>
           <div
  style={{
    marginTop: "1rem",
    padding: "0.75rem",
    background: "rgba(212,160,23,0.08)",
    borderRadius: 8,
    border: "1px solid rgba(212,160,23,0.2)",
    textAlign: "center",
  }}
>
  <a
    href={qr}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      textDecoration: "none",
      color: "inherit",
      display: "block",
    }}
  >
    <img
      src={qr}
      alt="Donation QR Code"
      style={{
        width: "120px",
        height: "120px",
        objectFit: "contain",
        margin: "0 auto 0.6rem",
        display: "block",
        borderRadius: "8px",
        background: "#fff",
        padding: "5px",
      }}
    />

    <span
      style={{
        color: "var(--gold)",
        fontSize: "0.85rem",
        fontWeight: 600,
      }}
    >
      Scan QR Code to Donate
    </span>
  </a>
</div> 
           
          </div>
        </div>

        <div style={{ borderTop: "1px solid rgba(255,255,255,0.08)", paddingTop: "1.5rem", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "0.75rem", fontSize: "0.82rem" }}>
          <span>© 2026 Birati Child Care Foundation. All rights reserved. </span>
          <span style={{ color: "rgba(255,255,255,0.4)" }}>Made with <Heart size={11} style={{ display: "inline", color: "#D4A017" }} /> by AI services</span>
        </div>
      </div>
    </footer>
  );
}
